import React, { Fragment, Component, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import PropTypes from 'prop-types';

import NotificationMobile from '../Notification/Mobile/NotificationMobile';
import History from '../../history';
import s from './GlobalHeader.css';
import logo from './assets/logo.png';
import notif from './assets/play.png';
import loop from './assets/loop.png';
import hamburgerLogo from '@global/assets/images/hamburger.svg';

import closeLogo from '@global/assets/images/x.svg';
import Link from '@components/Link';

import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import fb from './assets/fb.png';
import tw from './assets/tw.png';
import insta from './assets/insta.png';
import youtube from './assets/YoutubeIcon.png';
// import chatLogo from '@global/assets/images/lvsp2.png';
import chatLogo from '@global/assets/images/chatWithUs.png';
import ssLogo from '@global/assets/images/sslogo.png';

let isNotifClosed = true;
class GlobalHeader extends Component {
  state = {
    path: ''
  };

  handleSearch = () => {
    History.push('/search');
  };

  handleLiveSupport = () => {
    window.open('/livesupport', '_blank');
  };

  handleClickBack = () => {
    History.goBack();
  };

  componentDidMount() {
    if (window) {
      const fullURL = window.location.href;
      let path = fullURL.replace(/^(?:\/\/|[^\/]+)*\//, '/');
      this.setState({ path: path });
    }
  }

  render() {
    const assets = {
      logoUrl: ssLogo,
      searcIcon: loop,
      notifIcon: notif
    };

    let menus = [];
    const menu_headers = _get(this.props, 'runtime.menu_headers', []);
    if (menu_headers.length > 0) {
      const menuFromServer = menu_headers.reduce((array, menu) => {
        const menu_url = _get(menu, 'attributes.url', '');
        let menu_text = _get(menu, 'attributes.title.id', null);

        if (!menu_text) {
          menu_text = _get(menu, 'attributes.title.en', '');
        }

        array.push({
          title: menu_text,
          url: menu_url
        });
        return array;
      }, []);
      menus = menus.concat(menuFromServer);
    }

    const { isOpen } = this.props.liveNotification;
    let wrapperClass;
    if (isNotifClosed) {
      wrapperClass = s.wrapperContainerClose;
    } else {
      wrapperClass = isOpen ? s.wrapperContainerOpen : s.wrapperContainerClose;
    }

    return (
      <Fragment>
        <div className={s.wrapperContainerClose}>
          <div className={s.container_header}>
            <NotificationMobile />
            <div className={s.main_container}>
              <a className={s.left_container} href="/">
                <img alt="" src={assets.logoUrl} />
              </a>
              <div className={s.right_container}>
                {/* hide search */}
                {/* <img className={s.loop_search} alt="#" src={assets.searcIcon} onClick={this.handleSearch} /> */}
                {/* <img alt="#" src={assets.notifIcon} /> */}
              </div>
              <div className={s.clear} />
            </div>
            <MobileMenu page={this.props.page} items={menus} />
          </div>
        </div>
      </Fragment>
    );
  }
}

class MobileMenu extends Component {
  state = {
    isShowMenu: false,
    path: ''
  };

  componentDidMount() {
    if (window) {
      this.setState({ path: window.location.pathname });
    }
  }

  handleLiveSupport = () => {
    window.open('/livesupport', '_blank');
  };

  toggleMenu = () => {
    this.setState({
      isShowMenu: !this.state.isShowMenu
    });
  };

  render() {
    const assets = {
      fb: fb,
      tw: tw,
      insta: insta,
      youtube: youtube
    };

    return (
      <div className={s.menuWrap}>
        <button
          className={s.mobileButton}
          onClick={e => {
            e.preventDefault();
            this.toggleMenu();
          }}
        >
          <img src={hamburgerLogo} />
        </button>
        <div className={s.chat_container} onClick={this.handleLiveSupport}>
          <img src={chatLogo} />
        </div>

        {this.state.isShowMenu && (
          <div className={s.menuContent}>
            <div className={s.itemWrap}>
              <button
                className={s.mobileButton}
                onClick={e => {
                  e.preventDefault();
                  this.toggleMenu();
                }}
              >
                <img src={closeLogo} />
              </button>
              <ul>
                {this.props.items &&
                  this.props.items.map(menu => {
                    let isHome = false;
                    if (
                      _kebabCase(menu.title) === 'home' ||
                      _kebabCase(menu.title) === 'beranda'
                    ) {
                      isHome = true;
                    }

                    const relMenuUrl = isHome
                      ? '/'
                      : '/' + menu.url.replace(/^(?:\/\/|[^\/]+)*\//, '');

                    return (
                      <li key={menu.title}>
                        <a
                          href={menu.url}
                          className={[
                            s.menuItem,
                            this.state.path === relMenuUrl ? s.menuActive : null
                          ].join(' ')}
                        >
                          {menu.title}
                        </a>
                      </li>
                    );
                  })}
              </ul>

              <div className={s.footer_social}>
                <a href="https://www.facebook.com/TVSuperSoccer/">
                  <img alt="facebook icon" src={assets.fb} />
                </a>
                <a href="https://twitter.com/my_supersoccer">
                  <img alt="twitter icon" src={assets.tw} />
                </a>
                <a href="https://www.instagram.com/mysupersoccer/">
                  <img alt="instagram icon" src={assets.insta} />
                </a>
                <a href="https://www.youtube.com/channel/UCSM0oVXkkPrnvx902advygA/featured">
                  <img alt="Youtube icon" src={assets.youtube} />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};

export default compose(withStyles(s), connect(mapStateToProps))(GlobalHeader);
